import { Link } from '@remix-run/react';
import { Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import Icon from '~/components/icons/Icon';
import { useCustomer } from '~/context/CustomerContext';
import { useRoutePath } from '~/hooks/useRoutePath';

const getInitials = (firstName?: string | null, lastName?: string | null, email?: string): string => {
  if (firstName && lastName) {
    return `${firstName.charAt(0)}${lastName.charAt(0)}`.toUpperCase();
  }
  if (firstName) {
    return firstName.charAt(0).toUpperCase();
  }
  if (email) {
    return email.charAt(0).toUpperCase();
  }
  return '?';
};

const UserNavigation = ({ showLabel = true }) => {
  const { customer } = useCustomer();
  const routePath = useRoutePath();
  const { t } = useTranslation();

  const initials = customer ? getInitials(customer.firstName, customer.lastName, customer.email) : null;

  return (
    <Col xs="auto">
      <div className="d-lg-flex align-items-center gap-2">
        <Link
          to={customer ? routePath('accountDashboard') : routePath('login')}
          className="link-reset header__login d-flex align-items-center text-decoration-none"
          aria-label={customer ? t('my_account') : t('login_register')}
          rel="nofollow"
        >
          {customer && initials ? (
            <span className="header__user-initials">{initials}</span>
          ) : (
            <Icon name="customer" size={24} aria-hidden="true" />
          )}

          {showLabel && (
            <span className="d-block d-lg-none ms-2 fw-semibold">
              {customer ? t('my_account') : t('login_register')}
            </span>
          )}
        </Link>
      </div>
    </Col>
  );
};

export default UserNavigation;
